import {enableProdMode, provideCheckNoChangesConfig, provideZoneChangeDetection} from '@angular/core';
import {platformBrowser} from '@angular/platform-browser';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {ErrorNotificationService} from './app/core/error-notification.service';

if (environment.production) {
    enableProdMode();
}

// We are confident that using this method can catch all of:
// - Angular errors, since we rethrow them to console.error from the global error handler
// - Errors from third-party libraries, as they log issues using console.error
// - Unhandled promise rejections
// - window.onerror, as they usually get handled by Angular or show up in the console
// We prefer to ignore errors from browser extensions, since they’re not part of our app and each user could have different extensions
const {exhaustiveChangeDetectionCheck} = environment as {exhaustiveChangeDetectionCheck?: boolean};

const applicationProviders = exhaustiveChangeDetectionCheck === true
    ? [provideZoneChangeDetection(), provideCheckNoChangesConfig({exhaustive: true})]
    : [provideZoneChangeDetection()];

platformBrowser().bootstrapModule(AppModule, {applicationProviders}).then(moduleRef => {
    const errorNotificationService = moduleRef.injector.get(ErrorNotificationService);
    const originalConsoleError = console.error;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    console.error = (...args: any[]): void => {
            errorNotificationService.markErrorOccurred();
        originalConsoleError.apply(console, args);
    };
}).catch(err => console.error(err));
